var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardTable',{attrs:{"loading":_vm.loadingCycles,"header":"Cycle History","tableHeaders":_vm.headers,"tableData":_vm.recentCycleTableData,"allTableData":_vm.recentCycleList}})
}
var staticRenderFns = []

export { render, staticRenderFns }